(async () => {
    const { Core } = await importModule('Core');
    const PREFIX_BUY_WITH = 'buy_with_';
    const LINE_ITEM_PROPS_REGEXP = /(?<=\[).+?(?=\])/;
    customElements.define('product-form', class extends Core {
        elements = {
            formTargeter: '[data-product-form-targeter]',
            toCartButton: 'product-to-cart'
        };

        render() {
            if (!this.$formTargeter) return;
            this.$form = this.$formTargeter.form;
            this.$form?.addEventListener('submit', this._submitHandler.bind(this));
        }

        _submitHandler(event) {
            if (event.defaultPrevented) return;
            event.preventDefault();

            const items = this.cartItems;
            this.$toCartButton.addToCart(items, this.mainVariantId);
        }

        _isVariantInput([inputName, value]) {
            if (inputName === 'selling_plan') this._setSellingPlan(value);
            return inputName.includes(PREFIX_BUY_WITH) || inputName === 'id';
        }

        _setSellingPlan(id) {
            this.sellingPlanId = id;
        }

        _setCartItem([inputName, value]) {
            if (inputName === 'id') this.mainVariantId = value;
            const sellingPlanId = this.sellingPlanId || '';

            return {
                id: value,
                quantity: this._getItemQty(inputName),
                selling_plan: inputName === 'id' ? sellingPlanId : '',
                properties: this._getProperties(inputName)
            };
        }

        _getItemQty(inputName) {
            return inputName === 'id' ? this.qty : 1;
        }

        _getProperties(inputName) {
            return inputName === 'id' ? this.properties : {};
        }

        get cartItems() {
            return Array.from(this.formData.entries())
                .filter(this._isVariantInput.bind(this))
                .map(this._setCartItem.bind(this));
        }

        get formData() {
            return new FormData(this.$form);
        }

        get qty() {
            return +this.formData.get('quantity') || 1;
        }

        get properties() {
            return Array.from(this.formData.entries()).reduce((acc, [key, val]) => {
                if (key.startsWith('properties[') && key.endsWith(']') && val) {
                    const match = key.match(LINE_ITEM_PROPS_REGEXP);
                    if (match?.[0]) acc[match[0]] = val;
                }
                return acc;
            }, {});
        }
    });
})();
